import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as BiSearch  from "react-icons/bi";
import "./content.scss"


const ContentPost = () => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [contentData, setContentData] = useState([])
    const [SearchContData, seTSearchContData] = useState([])
    // const [Images, setImages] = useState('')
    const [ForId, setForId] = useState('')
    const [show, setShow] = useState(false);
    const [handlefetch, setHandleFetch] = useState(false);
    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)
    // const [picUrl, setPicUrl] = useState("")
    const navigate = useNavigate()
    // const [fetchHandle, setFetchHandle] = useState(false)
    useEffect(() => {
        FETCHDATA()
    }, [handlefetch])

    const handleSearch=(e)=>{
        let filteredData=contentData.filter((elm)=>{
         return  elm.title.toLowerCase().includes(e.target.value.toLowerCase())
        })
        seTSearchContData(filteredData)
    }

   
    const FETCHDATA = async () => {
        let result = await fetch("https://roadmap-backend.herokuapp.com/api/content/data", {
            method: "get",
            headers: {
                "content-type": "application/json",
            },
        })
        const result2 = await result.json()
        setContentData(result2)

    }
    const EditButtonClick = (_id) => {
        let Update = contentData.find((curelem) => {
            return curelem._id === _id;
        })
        setTitle(Update?.title)
        setDescription(Update?.description);
        setForId(Update)

        handleShow()

    }
    const EditForPost = async () => {
        let _id = ForId._id
        let result = await fetch(`https://roadmap-backend.herokuapp.com/api/content/data/${_id}`, {
            method: "put",
            body: JSON.stringify({ title, description }),
            headers: {
                "content-type": "application/json"
            }
        })
        const result3 = await result.json()
        setHandleFetch(!handlefetch)
        setTitle('')
        setDescription('')
        handleClose()
    }
    const DeleteButtonClick = async (_id) => {
        let result = await fetch(`https://roadmap-backend.herokuapp.com/api/content/data/${_id}`,
            {
                method: 'DELETE',
                headers: {
                    "content-type": "application/json"
                }
            })
        const result4 = await result.json()
        setHandleFetch(!handlefetch)
    }
   const   BackButton=()=>{
    navigate("/ContentPage")
   }
  
    return (
        <div>
        <div className='searchiconalldiv'>
        <div><button className='backbtnstyledivdiv' onClick={BackButton}>Back</button></div>
            <input type="text" className='searchdivinputdiv' onChange={(e)=>handleSearch(e)} />
          <button className='icondivstylediv'><BiSearch.BiSearch/></button>
        </div>
            <div >
                {
                   SearchContData.length > 0 ? SearchContData .map((elm) => {
                    return (
                    
                    <div className='backshowdatadiv'>
                            <label>Title</label>
                            <div className='showsdatatitle'>{elm.title} </div>
                            <div className='showsdatadescription'>{elm.description} </div>
                            <div className='showsdatapicture'><img className='imgpicdivallstyle' src={elm.picture} /></div>
                            <div className='showsDataforEditanddelete'> <button className='showsdatadataaForEdit' onClick={() => EditButtonClick(elm._id)}>Edit</button>
                                <button className='showsdatadataa' onClick={() => DeleteButtonClick(elm._id)}>Delete</button> </div>
                        </div>
                    )
                })
                   : contentData.map((elm) => {
                        return (
                            <div className='backshowdatadiv'>
                                <label>Title</label>
                                <div className='showsdatatitle'>{elm.title} </div>
                                <div className='showsdatadescription'>{elm.description} </div>
                                <div className='showsdatapicture'><img className='imgpicdivallstyle' src={elm.picture} /></div>
                                <div className='showsDataforEditanddelete'> <button className='showsdatadataaForEdit' onClick={() => EditButtonClick(elm._id)}>Edit</button>
                                    <button className='showsdatadataa' onClick={() => DeleteButtonClick(elm._id)}>Delete</button> </div>

                            </div>
                        )
                    })
                    
                    
                    }
            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>

                </Modal.Header>

                <Modal.Footer>
                    <input type="text" id="fname" name="firstname" placeholder="Your Title" style={{ width: '15rem', height: '2rem' }}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)} />
                    <textarea className='modlinputdescdiv' type="text" id="fname" name="firstname" placeholder="Your Description." 
                        value={description}
                        onChange={(e) => setDescription(e.target.value)} />

                    <button className='btnstylestyless' onClick={EditForPost} style={{ width: '8rem', height: '2rem' }} >Post Content</button>

                </Modal.Footer>
            </Modal>


        </div>
    )
}

export default ContentPost